'use strict';

module.exports = require('./dom-scroll-into-view');


//////////////////
// WEBPACK FOOTER
// ./node_modules/.1.2.1@dom-scroll-into-view/lib/index.js
// module id = 89
// module chunks = 1